import {
  type UseMutationOptions,
  type UseMutationResult,
  useMutation,
} from '@tanstack/react-query';

import api from 'src/axios';
import type { SessionSummary } from 'src/services/api/getForecastSessions';

type CreateForecastSessionVariables = {
  name: string;
};

export function useCreateForecastSession(
  options?: Omit<
    UseMutationOptions<SessionSummary, Error, CreateForecastSessionVariables>,
    'mutationFn'
  >,
): UseMutationResult<SessionSummary, Error, CreateForecastSessionVariables> {
  return useMutation({
    mutationFn: async ({ name }: CreateForecastSessionVariables) => {
      const { data } = await api.post<SessionSummary>(
        '/sales-forecasting-sessions/',
        { name },
      );

      return data;
    },
    ...options,
  });
}
